import { useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import "./LoginModal.css";
import { Col, Row } from "react-bootstrap";

const LoginModal = ({
  title,
  onSubmit,
  buttonLabel,
  inputs,
  logoSrc,
  footer,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className="loginModalContainer">
      {logoSrc && (
        <div className="login-logo-container">
          <img src={logoSrc} alt="logo" className="login-logo" />
        </div>
      )}
      <h2 className="signIn-title">{title}</h2>
      <div className="signInContent">
        <form
          noValidate
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit();
          }}
        >
          {inputs.map((row, rowIndex) => (
            <Row key={rowIndex} className="loginModal-row">
              {row.map((input, colIndex) => (
                <Col key={colIndex} xs={12}>
                  <div className="input-container">
                    {input.icon && (
                      <input.icon
                        style={{ color: "white", fontSize: "18px" }}
                      />
                    )}
                    <input
                      type={
                        input.type === "password"
                          ? showPassword
                            ? "text"
                            : "password"
                          : input.type
                      }
                      autoComplete="off"
                      placeholder={input.placeholder}
                      value={input.value}
                      onChange={input.onChange}
                      name={input.name}
                      className={`${input.className || ""} dark-input`}
                      data-testid={
                        input.name === "email" 
                          ? "login-email-input" 
                          : input.name === "password" 
                            ? "login-password-input" 
                            : undefined
                      }
                    />
                    {input.type === "password" && (
                      <span
                        onClick={togglePasswordVisibility}
                        className="eye-icon"
                      >
                        {showPassword ? (
                          <VisibilityOff
                            style={{ color: "white", fontSize: "22px" }}
                          />
                        ) : (
                          <Visibility
                            style={{ color: "white", fontSize: "22px" }}
                          />
                        )}
                      </span>
                    )}
                  </div>
                </Col>
              ))}
            </Row>
          ))}
          <button 
            type="submit"
            data-testid="login-submit-button"
          >
            {buttonLabel}
          </button>
          {footer}
        </form>
      </div>
    </div>
  );
};

export default LoginModal;